export const WHAT_AREA_IS_YOUR_SCHOOL_LOCATED_IN = [
  'Urban (within the limits of a major city with a population of at least 50,000)',
  'Inner City (located within a major city & characterized by a concentration of greater than 40% low income)',
  'Suburban (outside of, but tangent to, a major city or its immediate suburbs)',
  'Rural (located outside of an urban or suburban area and having fewer than 50,000 inhabitants)',
]

export const SCHOOL_GRADES = [
  'PK',
  'K',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
]

export const RELIGIOUS_AFFILIATIONS = [
  'Adventist',
  'Anglican',
  'Baptist',
  'Buddhism',
  'Catholic – Diocese',
  'Catholic – Independent',
  'Catholic - Ordered',
  'Classical Christian',
  'Episcopal',
  'Greek Orthodox',
  'Hinduism',
  'Islamic',
  'Jewish',
  'Latter Day Saints',
  'Lutheran, Methodist',
  'Non-Denominational Christian',
  'Non-Sectarian/Not Religious',
  'Pentecostal',
  'Presbyterian',
]

export const COED_STATUS_OPTIONS = ['All Boys', 'All Girls', 'Co-Educational']

export const HYBRID_STATUS_OPTIONS = [
  'Hybrid/Non-Homeschool',
  'In Person',
  'Online',
]

export const AREAS_OF_SPECIALIZATION = [
  'None',
  'CTE (Career & Technical Education)',
  'ESL/Dual Language',
  'IB (International Baccalaureate)',
  'Montessori',
  'Performing Arts',
  'Special Ed/Learning Differences/Exceptionalities',
  'STEAM (Science, Technology, Engineering, Arts, & Math)',
  'STEM (Science, Technology, Engineering, & Math)',
]

export const LEARNING_DIFFERENCES = [
  'None',
  'Autism',
  'Developmental Delay',
  'Educationally Handicapped',
  'Emotional Disturbance',
  'Hearing Impairment - Deafness',
  'Intellectual Disability - Mild',
  'Intellectual Disability - Moderate',
  'Intellectual Disability - Severe',
  'Intellectual Disability - Profound',
  'Other Health Impairment',
  'Orthopedic Impairment',
  'Severe Learning Disability',
  'Speech or Language Impairment - Fluency',
  'Speech or Language Impairment - Language',
  'Speech or Language Impairment - Voice',
  'Specific Learning Disability (Dyslexia, Dysgraphia, etc.)',
  'Traumatic Brain Injury',
  'Visual Impairment - Blindness',
]

export const ADDITIONAL_PROGRAMS = [
  'None',
  'After School Care',
  'AICE (Advanced International Certificate of Education)',
  'AP (Advanced Placement)',
  'Art',
  'Before School Care',
  'College Prep',
  'Culinary Arts',
  'Dual Enrollment',
  'Foreign Language',
  'Honors',
  'IB (International Baccalaureate)',
  'Music',
  'Other/Not Listed',
  'PE',
  'Robotics',
  'Service Learning',
  'Vocational',
]
export const ACCREDITATION_BODIES = [
  'AdvancED/Cognia',
  'Global Education Accrediting Commission (GEAC)',
  'Association Montessori Internationale (AMI)',
  'Association of Christian Schools International (ACSI)',
  'Association of Independent Schools in New England (AISNE)',
  'Independent Schools Association of the Central States (ISACS)',
  'Middle States Association of Colleges and Schools (MSA)',
  'Middle States Commission on Elementary and Secondary Schools (MSCESS)',
  'National Association of Independent Schools (NAIS)',
  'Association of Colorado Independent Schools (ACIS)',
  'California Association of Independent Schools (CAIS/CA)',
  'Connecticut Association of Independent Schools (CAIS/CT)',
  'Council of International Schools (CIS)',
  'Florida Council of Independent Schools (FCIS)',
  'Hawaii Association of Independent Schools (HAIS)',
  'New Jersey Association of Independent Schools (NJAIS)',
  'New York State Association of Independent Schools (NYSAIS)',
  'Pennsylvania Association of Independent Schools (PAIS)',
  'Virginia Association of Independent Schools (VAIS)',
  'Independent Schools Association of the Southwest (ISAS)',
  'New England Association of Schools and Colleges (NEASC)',
  'Northwest Association of Independent Schools (NWAIS)',
  'Southern Association of Independent Schools (SAIS)',
  'Southwestern Association of Episcopal Schools (SAES)',
  'The Association of Independent Maryland and DC Schools (AIMS)',
  'National Council for Private School Accreditation (NCPSA)',
  'Accreditation International (AI)',
  'Accrediting Association of Seventh-day Adventist Schools',
  'American International Accreditation Association of Schools and Colleges (AIAASC)',
  'American Montessori Society (AMS)',
  'Array Global Accreditation',
  'Association of Christian Teachers and Schools (ACTS)',
  'Association of Classical Christian Schools',
  'Association of Independent Schools of Florida (AISFL)',
  'Association of Waldorf Schools of North America (AWSNA)',
  'Christian Schools of Florida (CSF)',
  'ISEI Education Association (ISEIEA)',
  'Florida Coalition of Christian Private School Accreditation (FCCPSA)',
  'International Christian Accrediting Association (ICAA)',
  'Florida Association of Christian Colleges and Schools (FACCS)',
  'Florida Catholic Conference',
  'Kentucky Non-Public School Commission',
  'Middle States Association – Commissions on Elementary and Secondary Schools (MSA - CESS',
  "National Accreditation Board of Merkos L'Inyonei Chinuch",
  'National Alliance of Christian Schools (NACS)',
  'National Independent Private Schools Association (NIPSA)',
  'North American Christian School Accrediting Agency (NACSAA)',
  'Wisconsin Evangelical Lutheran Synod School Accreditation (WELSSA)',
  'Texas Private School Accreditation Commission (TEPSAC)',
  'Virginia Council for Private Education (VCPE)',
  'Commission on Independent Schools (NEASC-CIS)',
  'North Central Association Commission on Accreditation and School Improvement (NCA CASI)',
  'AdvancED North Central',
  'Northwest Association of Accredited Schools (NAAS)',
  'National Federation of Nonpublic School State Accrediting Associations (NFNSSAA)',
  'Arkansas Nonpublic School Accrediting Association (ANSAA)',
  'Michigan Nonpublic School Accrediting Association (MNSAA)',
  'Minnesota Nonpublic School Accrediting Association (MNSAA)',
  'Missouri Nonpublic School Accrediting Association (MNSAA)',
  'National Federation of Wisconsin Independent and Religious Schools Accreditation (WRISA)',
  'Alabama Independent School Association (AISA)',
  'Florida Association of Academic Nonpublic Schools (FAANS)',
  'Georgia Accrediting Commission, Inc.',
  'Georgia Private School Accreditation Council (GAPSAC)',
  'Illinois State Board of Education (ISBE)',
  'Michigan: University of Michigan (Bureau of School Services)',
  'Minnesota Independent School Association (MISA)',
  'Mississippi Association of Independent Schools (formerly the Mississippi Private School Association)',
  'Missouri: University of Missouri',
  'New York Schools of the Archdiocese of NY',
  'New York: University of the State of New York',
  'North Carolina Division for Nonpublic Education (NCDNE)',
  'Ohio Catholic School Accrediting Association (OCSAA)',
  'South Carolina Independent School Association (SCISA)',
  'Tennessee Association of Non-Public Academic Schools (TANAS)',
  'Texas Catholic Conference (TCC)',
  'Wisconsin Nonpublic School Accrediting Association (WNSAA)',
  'Wisconsin Independent and Religious Schools Accreditation (WRISA)',
  'Southern Association of Colleges and Schools (SACS)',
  'AdvancED South',
  'Western Association of Schools and Colleges (WASC)',
  'Accrediting Commission for Schools (WASC-ACS)',
  'Western Catholic Educational Association (WCEA)',
]

export const VARIABLE_TUITION_OPTIONS = [
  'None',
  'Tuition is based upon student teacher ratio rather than grade',
  'Families receive a discount for the 3rd 4th 5th etc. student in a family',
  'Family members employed by the school receive a discount',
  'Parish discount',
]

export const PRIMARY_CONTACT_ROLE_OPTIONS = [
  'School Principal/Leader',
  'Administrator',
  'Assessment Coordinator',
  'Finance Contact',
  'Other',
]

export const STANDARDIZED_TESTS = [
  'ACT Aspire',
  'AMP',
  'Aspire',
  'AZMerit',
  'California Achievement Test (CAT)',
  'Classic Learning Test (CLT)',
  'College Entrance Exam - Scholastic Assessment Test (SAT)',
  'College Entrance Exame - American College Test (ACT)',
  'College Entrance Exame - Classic Learning Test (CLT)',
  'Colorado Measures of Academic Success (CMAS)',
  'Development Reading Assessment (DRA)',
  'Dynamic Indicators of Basic Early Literacy Skills (DIBELS)',
  'ERB Testing',
  'International Baccalaureate (IB)',
  'Iowa Test of Basic Skills (ITBS)',
  'Kansas Assessment Program (KAP)',
  'Keystone',
  'Louisiana Educational Assessment Program (LEAP)',
  'Maryland Comprehensive Assessment Program (MCAP)',
  'Measures of Academic Progress (MAP) Testing',
  'Missouri Assessment Program (MAP)',
  'New Mexico Measures of Student Success and Achievement (NM-MSSA)',
  'Other not listed here',
  'Partnership for Assessment of Readiness for College and Careers (PARCC)',
  'Pennsylvania System of School Assessment (PSSA)',
  'PSAT/National Merit Scholarship Qualifying Test (NMSQT)',
  'Readiness Improvement Success Empowerment (RISE)',
  'Smarter Balanced Assessment Consortium (SBAC)',
  'Standards of Learning (SOL)',
  'Stanford Achievement Test (SAT 10)',
  'STAR Assessments',
  'State of Texas Assessments of Academic Readiness (STAAR)',
  'TerraNova',
  'Wide Range Achievement Test (WRAT)',
  'Wyoming Test of Proficiency and Progress (WY-TOPP)',
]
